import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefinancingIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 37,
	height: 30,
	viewBox: "0 0 37 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M35.5 3.55v8.5h-9.35M1.5 25.65v-8.5h9.35",
		stroke: "#031839",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.38 10.066a13.592 13.592 0 013.871-5.63 14.023 14.023 0 016.17-3.1 14.21 14.21 0 016.935.2 13.978 13.978 0 015.973 3.45l7.171 6.591m-34 6.046l7.17 6.59a13.978 13.978 0 005.974 3.451c2.257.639 4.643.708 6.934.2a14.022 14.022 0 006.17-3.1 13.591 13.591 0 003.873-5.63",
		stroke: "#031839",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgRefinancingIcon;
